// Dynamic recurring-task titles. A rule's title may embed date tokens that are
// expanded against the occurrence date at materialization time, so a daily rule
// titled `Tasks $YYYY-$MMM-$DD` spawns `Tasks 2026-May-18`, `Tasks 2026-May-19`,
// and so on.
//
// Tokens (case-sensitive):
//   $YYYY → 4-digit year         (2026)
//   $MMM  → short month name      (Jan, Feb, … May … Dec)
//   $DD   → 2-digit day of month  (01 … 31)
//
// English month abbreviations are fixed (not locale-derived) so web and Android
// expand the same slot to the same text — important since both clients can
// materialize the same occurrence.
const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/**
 * Expand the date tokens in `title` against `dateMillis` (epoch millis).
 * Returns the title unchanged when it contains no `$`.
 */
export function expandTitleTemplate(title, dateMillis) {
  if (!title || title.indexOf("$") === -1) return title;
  const d = new Date(dateMillis);
  const yyyy = String(d.getFullYear());
  const mmm = MONTHS_SHORT[d.getMonth()];
  const dd = String(d.getDate()).padStart(2, "0");
  return title
    .replace(/\$YYYY/g, yyyy)
    .replace(/\$MMM/g, mmm)
    .replace(/\$DD/g, dd);
}

/** Whether a title uses any dynamic token (drives the live preview in the UI). */
export function hasTitleTokens(title) {
  return !!title && /\$YYYY|\$MMM|\$DD/.test(title);
}

// Shown in the rule editor's "?" help popover.
export const TITLE_TEMPLATE_HELP_LINES = [
  "Use date tokens in the title and they're filled in with each task's date:",
  "$YYYY  →  year (2026)",
  "$MMM  →  month (May)",
  "$DD  →  day (18)",
  'Example: "Tasks $YYYY-$MMM-$DD"  →  "Tasks 2026-May-18"',
];
